export function createRange(start: number, end: number, step: number): number[] {
    return Array(Math.ceil((end - start) / step)).fill(start).map((x, y) => x + y * step);
}

export function randomNumber(min: number, max: number, exceptValue: number): number {
    let num = Math.floor(Math.random() * (max - min + 1)) + min;
    return (num === exceptValue) ? randomNumber(min, max, exceptValue) : num;
}

export function roundToBottom(v: number) {
    return (v >= 0 ? Math.floor(Math.abs(v)) : -1 * Math.ceil(Math.abs(v)));
}

export function roundToTop(v: number) {
    return (v >= 0 ? 1 : -1) * Math.ceil(Math.abs(v));
}

export function mean(arr: number[]) {
    return arr.reduce((acc, num) => acc + num, 0) / arr.length;
}

export function meanBy(arr: any[], selector: (item: any) => number) {
    if (arr.length === 0)
        return null;

    return arr.reduce((acc, item) => acc + selector(item), 0) / arr.length;
}
